'use client';

import { User } from 'lucide-react';
import { tmdb } from '@/lib/tmdb';
import { PosterCard } from '@/components/PosterCard';

interface PersonCardProps {
  person: {
    id: number;
    name: string;
    profile_path?: string | null;
    known_for_department?: string;
  };
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export function PersonCard({ person, size = 'medium', className = '' }: PersonCardProps) {
  return (
    <PosterCard
      href={`/person/${person.id}`}
      imageUrl={person.profile_path ? tmdb.getImageUrl(person.profile_path, 'w500') : null}
      title={person.name}
      subtitle={person.known_for_department}
      placeholderIcon={<User className="h-16 w-16 text-gray-600" />}
      size={size}
      className={className}
    />
  );
}
